<template>
    <div>
      <v-dialog v-model="dialog" max-width="500" :fullscreen="isMobile" persistent>
        <template v-slot:activator="{ on, attrs }">
         

          <v-btn color="primary" v-bind="attrs" v-on="on"
    >
    DEFINIR UBICACIÓN
      <v-icon
        right
        dark
      >
      fa-solid fa-location-dot
      </v-icon>
    </v-btn>

        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ title }}</span>
            <v-spacer></v-spacer>
        <v-icon @click="resetSelection"> fa-solid fa-xmark </v-icon>
          </v-card-title>
  
          <v-sheet class="overflow-y-auto" :style="{ maxHeight: height + 'px' }">
            <div v-if="error" class="error">{{ error }}</div>
            <div v-else>
              <gmap-map
                :center="mapCenter"
                :zoom="15"
                :style="{ height: height + 'px' }"
                @click="placeMarker"
              >
                <gmap-marker
                  v-if="markerPosition"
                  :position="markerPosition"
                  :draggable="true"
                  @dragend="updateMarkerPosition"
                  
                >
                 
                </gmap-marker>
              </gmap-map>
              
            </div>
          </v-sheet>
  
          <v-card-actions>
            <v-spacer></v-spacer>
           
            <v-btn color="primary" text @click="openInGoogleMaps" :disabled="!markerPosition">Google Maps</v-btn>
            <v-btn color="primary" text @click="saveLocation">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: "Seleccione una Ubicación",
      },
      isMobile: {
        type: Boolean,
        default: false,
      },
      height: {
        type: Number,
        default: 500,
      }
    },
    data() {
      return {
        error: null,
        dialog: false,
        markerPosition: null,
        mapCenter: { lat: 0, lng: 0 },       
        
      };
    },
    mounted() {
      this.getUserLocation();
    },
    methods: {
      resetSelection() {
        this.dialog = false;
        this.$emit('reset');
      },
      getUserLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              this.mapCenter = { lat: latitude, lng: longitude };
              this.markerPosition = this.mapCenter;
            },
            (error) => {
              this.error = "No se pudo obtener la ubicación.";
              console.error(error);
            }
          );
        } else {
          this.error = "La geolocalización no es compatible con este navegador.";
        }
      },
      placeMarker(event) {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        this.markerPosition = { lat, lng };
        this.mapCenter = { lat, lng };
        
      },
      updateMarkerPosition(event) {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        this.markerPosition = { lat, lng };
      },
      
      saveLocation() {
        if (this.markerPosition) {
          this.$emit('locationSaved', this.markerPosition);
          this.resetSelection();
        } else {
          this.error = "No se ha colocado ningún marcador.";
        }
      },
      openInGoogleMaps() {
        if (this.markerPosition) {
          const url = `https://www.google.com/maps?q=${this.markerPosition.lat},${this.markerPosition.lng}`;
          window.open(url, '_blank');
        } else {
          this.error = "No se ha colocado ningún marcador.";
        }
      }
    },
  };
  </script>
  
  <style scoped>
  .error {
    color: red;
  }
  </style>